export default {
    square: 'square',
    octagon: 'octagon'
}